"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LookupFieldValueGetter = void 0;
const arrays_1 = require("../../type-checking/arrays");
const base_calculated_fieldtype_1 = require("../base-calculated.fieldtype");
class LookupFieldValueGetter extends base_calculated_fieldtype_1.BaseCalculatedFieldValueGetter {
    constructor() {
        super(...arguments);
        this.isValidFieldValue = (fieldValue) => {
            return (0, arrays_1.isArrayValue)(fieldValue);
        };
        this.getEmptyValue = () => [];
    }
}
exports.LookupFieldValueGetter = LookupFieldValueGetter;
